import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableSelectionBarDefaultVariants = {}
const tableSelectionBarCompoundVariants = []

const tableSelectionBarSlotNames = [
  [
    "root",
    "table-selection-bar__root"
  ],
  [
    "icon",
    "table-selection-bar__icon"
  ],
  [
    "text",
    "table-selection-bar__text"
  ]
]
const tableSelectionBarSlotFns = /* @__PURE__ */ tableSelectionBarSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableSelectionBarDefaultVariants, getSlotCompoundVariant(tableSelectionBarCompoundVariants, slotName))])

const tableSelectionBarFn = memo((props = {}) => {
  return Object.fromEntries(tableSelectionBarSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableSelectionBarVariantKeys = []
const getVariantProps = (variants) => ({ ...tableSelectionBarDefaultVariants, ...compact(variants) })

export const tableSelectionBar = /* @__PURE__ */ Object.assign(tableSelectionBarFn, {
  __recipe__: false,
  __name__: 'tableSelectionBar',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tableSelectionBarVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, tableSelectionBarVariantKeys)
  },
  getVariantProps
})